import { render } from "./FileUploader.vue?vue&type=template&id=1bcbabc4&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=1bcbabc4&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcbabc4"]])

export default __exports__